/** TanStack Query keys for the build screens (workspace-scoped: always carry the workspace id). */
export const buildKeys = {
  agents: (ws: string) => ["ws", ws, "agents"] as const,
  agent: (ws: string, agentId: string) => ["ws", ws, "agents", agentId] as const,
  playgroundConfig: (ws: string, agentId: string) => ["ws", ws, "agents", agentId, "playground-config"] as const,
  versions: (ws: string, agentId: string) => ["ws", ws, "agents", agentId, "versions"] as const,
  promptPreview: (ws: string, agentId: string, text: string) => ["ws", ws, "agents", agentId, "prompt-preview", text] as const,
  models: (ws: string) => ["ws", ws, "agent-models"] as const,
  templates: ["industry-templates"] as const,
  teams: (ws: string) => ["ws", ws, "teams"] as const,
  members: (ws: string) => ["ws", ws, "members"] as const,
  assignableMembers: (ws: string) => ["ws", ws, "members", "assignable"] as const,
  sources: (ws: string) => ["ws", ws, "sources"] as const,
  trace: (ws: string, messageId: string) => ["ws", ws, "trace", messageId] as const,
  actions: (ws: string, agentId: string) => ["ws", ws, "agents", agentId, "actions"] as const,
  actionStats: (ws: string, agentId: string) => ["ws", ws, "agents", agentId, "actions", "stats"] as const,
  actionRuns: (ws: string, agentId: string) => ["ws", ws, "agents", agentId, "action-runs"] as const,
  evalSets: (ws: string, agentId: string) => ["ws", ws, "eval-sets", agentId] as const,
  evalCases: (ws: string, setId: string) => ["ws", ws, "eval-cases", setId] as const,
  evalRuns: (ws: string, setId: string, configOnly: boolean) => ["ws", ws, "eval-runs", setId, configOnly] as const,
  evalRun: (ws: string, runId: string) => ["ws", ws, "eval-run", runId] as const,
  evalResults: (ws: string, runId: string) => ["ws", ws, "eval-run", runId, "cases"] as const,
  evalCompare: (ws: string, a: string, b: string) => ["ws", ws, "eval-compare", a, b] as const,
} as const;
